import { apiClient } from './client';

export function bulkRemoveMembers (payload: { email: string; organization_ids: string[] }) {
  return apiClient.post('/auth0/organizations/bulk/members', payload);
}
